module.exports = __webpack_public_path__ + "static/media/profile.59dcba70.svg";